import {GET} from "../util";

const url = {
    businessConfig: {
        auctions: "api/common/business-config/auctions",
        trackAndPay: "api/common/business-config/trackpay"
    }
};
const businessConfigApi = {
    getAuctions: () => {
        return GET(url.businessConfig.auctions);
    },
    getTrackAndPay: () => {
        return GET(url.businessConfig.trackAndPay);
    }
};
export {
    businessConfigApi
};